import React from 'react';
import logo from './vdc-logo.jpg';

const VDCLogo = () => {
    return(
        <img src={logo} alt="logo" style={{width:"352px",height:"120px"}}/>
    );
  };
  
  export default VDCLogo;